import axios from "axios";

// Resolve API base:
//  - In the browser, if we're on a non-emergent domain (custom domain like zenithwellnesss.com),
//    use same-origin /api/* — which is what the production reverse-proxy serves.
//  - Otherwise fall back to the build-time env var (used by preview + local dev).
function resolveApiBase() {
    if (typeof window !== "undefined") {
        const host = window.location.hostname;
        const onEmergent = /(emergentagent\.com|emergent\.host|localhost|127\.0\.0\.1)$/i.test(host);
        if (!onEmergent) {
            return `${window.location.origin}/api`;
        }
    }
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
}

export const API = resolveApiBase();

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const fmtPrice = (n) =>
    `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
